import { Controller } from "stimulus"

export default class extends Controller {

  finalizeOnboarding() {
    this.wrappingModal.fireEvent('overlayFormHide');
    if (this.documentForm) {
      if (this.documentForm.classList.contains('needs-onboarding')) {
        this.documentForm.classList.remove('needs-onboarding');
      }
      this.documentForm.submit()
    }
    ga('send', 'event', 'onboarding', 'completed');
  }

  cancelOnboarding() {
    this.wrappingModal.fireEvent('overlayFormHide')
  }

  get wrappingModal() {
    return this.element.getParent('.modal-form')
  }

  get documentForm() {
    return document.querySelector('#create_or_edit_document_form')
  }
}